var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header',[_c('HeaderWhite')],1),_c('main',[_c('Carousel',{attrs:{"selectTagKey":_vm.projectKey}}),_c('ProjectContents',{attrs:{"selectProjectDataList":_vm.selectProjectDataList}})],1),_c('footer',[_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }